import React from 'react';
import styles from './ListPageHeader.module.css';
import Btn from './Btn';

const ICO_REFRESH = 'M21 12a9 9 0 1 1-2.64-6.36M21 3v6h-6';

export default function ListPageHeader({ title, subtitle, onReload }) {
  return (
    <div className={styles.header}>
      <div>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
      {onReload && (
        <div className={styles.actions}>
          <Btn variant="secondary" size="lg" icon={ICO_REFRESH} onClick={onReload}>Reload</Btn>
        </div>
      )}
    </div>
  );
}
